import { render, staticRenderFns } from "./RecommendationsForMe.vue?vue&type=template&id=78f12a79&scoped=true"
import script from "./RecommendationsForMe.vue?vue&type=script&lang=ts"
export * from "./RecommendationsForMe.vue?vue&type=script&lang=ts"
import style0 from "./RecommendationsForMe.vue?vue&type=style&index=0&id=78f12a79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f12a79",
  null
  
)

export default component.exports